import dynamic from 'next/dynamic'

const PhoneFormatter = dynamic(() => import('./formatter'))

export default PhoneFormatter
